import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { BuscarAlumno } from "../../API/Core";
import { BuscarCantidadAlumno } from "../../API/Core";
import { buscarCantidadChatSinLeer } from "../../API/Core";
import { buscarChatEnviar } from "../../API/Core";
import FilterField from "./FilterField";
import FilterEspecialista from "./FilterEspecialista";
import FilterPaciente from "./FilterPacientes";
import { Row, Col } from "reactstrap";
import ListaChats from "./ListaChats";
import Mensajes from "./Mensajes";
import Select from "react-select";
import { Link, Redirect } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { useNavigate } from "react-router-dom";
import { saveCliente, saveToken, saveBotonMensaje } from "../../accion/accion";
import axios from "axios";
//componentes
function Chat(props) {
  const [cedulaAlumno, setCedulaAlumno] = React.useState(null);
  const [idespecialista, setIdespecialista] = React.useState(null);
  const [chatSelected, setChatSelected] = React.useState(null);
  const [openvio, setOpenvio] = React.useState("1");
  const [refreshChats, setRefreshChats] = React.useState(0);
  const [cantAlumnos, setCantAlumnos] = React.useState([]);
  const [ilistaSalas, setIlistaSalas] = React.useState([]);
  const [has_message, setHas_message] = React.useState(false);
  const [listaSalaOn, setListaSalaOn] = React.useState(false);
  const [idsala, setIdsala] = React.useState("");

  // const InitData = async () => {
  //   try {
  //     let response = await BuscarCantidadAlumno(props.usuario1.password);
  //     setCantAlumnos(response.data.variable1);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const Seleccionar_Paciente = (paciente_selected) => {
    if (paciente_selected !== null) {
      setCedulaAlumno(paciente_selected);
      initData2(paciente_selected);
    }
  };

  const Seleccionar_Especialista = async (especialista) => {
    if (especialista !== null) {
      //console.log("eee " + especialista.cedula);
      setIdespecialista(especialista.cedula);
      setChatSelected({
        id: null,
        profesor: especialista.cedula,
        alumno: String(cedulaAlumno),
        // nombre_alumno:especialista.nombre_alumno,
        // materia: especialista.especialidad,
        nombre_Especialista: especialista.nombre,
      });
      //console.log(materia)
      try {
        let response = await buscarChatEnviar(
          especialista.cedula,
          cedulaAlumno,
          especialista.materia
        );
        response.data.variable2.map((item, i) => {
          //console.log("chat " + item.variable8);
          
          if (item.variable !== "") {
            setChatSelected({
              id: item.variable,
              profesor: item.variable3,
              alumno: item.variable4,
              nombre_alumno: item.variable5,
              materia: especialista.materia,
              // nombre_Especialista: props.nombreEsp,
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
  };

  const Seleccionar_Chat = (data) => {
    setChatSelected(data);
  };

  const onChange1 = (e) => {
    if (e !== null) {
      setOpenvio(e.target.value);
    }
    //else {
    //   setOpenvio(ne.target.value);
    // }
  };

  const salir = () => {
    // window.location.replace('0');
    // window.location.reload(true);
    //this.props.navigate('/login');
    //console.log("paso");
    return <Redirect to="/login" />;
  };

  const initData2 = async (e) => {
    console.log(e);
    let response = await buscarCantidadChatSinLeer(e);
    if (response.data.variable1) {
      props.saveBotonMensaje(true);
      setIlistaSalas(response.data.variable3);
    } else {
      props.saveBotonMensaje(false);
      setIlistaSalas([]);
    }
  };

  const listaSala = () => {
    if (listaSalaOn) {
      setListaSalaOn(false);
    }
    if (!listaSalaOn) {
      setListaSalaOn(true);
    }
    console.log(listaSalaOn);
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      initData2(cedulaAlumno);
    }, 10000);

    return () => clearInterval(interval);
  }, [cedulaAlumno]);

  const cargarSalaCreada = async () => {
    //console.log(e)
    //console.log(f);
    //setListaOn(false)
    if (idsala.length > 0) {
      console.log(idsala);
      let data = new FormData();
      data.append("idsala", idsala);
      data.append("boton", "consultaSalaCreada");
      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/chat.php";
      let respon = await axios.post(xurl, data);
      // let respon = await axios.post(xurl, data, config).then((res) => {
      if (respon.data.variable1) {
        setListaSalaOn(false);
        setIdespecialista(respon.data.variable4);
        try {
          let response = await buscarChatEnviar(
            respon.data.variable4,
            cedulaAlumno,
            respon.data.variable3
          );
          response.data.variable2.map((item, i) => {
            console.log("chat " + item.variable8);
            if (item.variable !== "") {
              setChatSelected({
                id: idsala,
                profesor: item.variable4,
                alumno: cedulaAlumno,
                nombre_alumno: item.variable6,
                materia:item.variable3,
              });
            }
          });
        } catch (err) {
          console.log(err);
        }

      } 
    }
  };

  React.useEffect(() => {
    props.saveBotonMensaje(false);
  }, []);

  return (
    <div>
      <Container>
        <FieldContainer7>
          <Span>Mensajeria Terapias</Span>
        </FieldContainer7>
        <FieldContainer>
          <FieldContainer4>
            <FieldContainer1>
              <FilterPaciente
                id_Paciente={props.usuario1.password}
                onChange={Seleccionar_Paciente}
              />
            </FieldContainer1>

            {cedulaAlumno !== null && (
              <FieldContainer2>
                <FilterEspecialista
                  id_alumno={cedulaAlumno}
                  onChange={Seleccionar_Especialista}
                />
              </FieldContainer2>
            )}
          </FieldContainer4>
          <FieldContainer6>
            <Salir>
              <Link to="/login">
                <FeatherIcon icon="log-out" stroke="#fff" size="18" />{" "}
              </Link>
            </Salir>

            <div className="usu-cabeceraC">
              {props.botonMen.botonMensaje === true && (
                <LinkContainer>
                  <Link>
                    <Boton onClick={listaSala}>
                      <BadgeNotification />
                      <FeatherIcon icon="list" size="10" stroke="#888" />
                    </Boton>
                  </Link>
                </LinkContainer>
              )}
              {props.botonMen.botonMensaje !== true && (
                <LinkContainer>
                  <Link>
                    <FeatherIcon icon="list" size="10" stroke="#888" />
                  </Link>
                </LinkContainer>
              )}
            </div>
          </FieldContainer6>
          <FieldContainer8>
            {listaSalaOn === true && (
              <Flotador3xM>
                <Flotador1>
                  <FieldContainer7>
                    <Span2>LISTA DE MENSAJES POR VISUALIZAR. </Span2>
                  </FieldContainer7>
                  <div className="fechas col-10">
                    <Selecte
                      id="idsala"
                      name="idsala"
                      value={idsala}
                      onChange={(e) => setIdsala(e.target.value)}
                    >
                      <option>-- Especialista --</option>
                      {ilistaSalas.map((item, i) => {
                        return (
                          <option key={item.variable1} value={item.variable1}>
                            {item.variable3}
                          </option>
                        );
                      })}
                    </Selecte>
                  </div>
                  <FechasL col-12>
                    <BotonS className="boton" onClick={cargarSalaCreada}>
                      VISUALIZAR
                    </BotonS>
                    <BotonS className="boton" onClick={listaSala}>
                      SALIR
                    </BotonS>
                  </FechasL>
                </Flotador1>
              </Flotador3xM>
            )}
          </FieldContainer8>
        </FieldContainer>

        {/* <Row className="mt-4">
          <Col>
            <ListaChats
              refreshChats={refreshChats}
              selected={chatSelected}
              id_alumno={cedulaAlumno}
              onClick={Seleccionar_Chat}
            />
          </Col>
        </Row> */}

        <MessagesContent>
          <Mensajes
            updatListChats={() => setRefreshChats(refreshChats + 1)}
            selected={chatSelected}
          />
        </MessagesContent>
      </Container>
      {/* )} */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
    botonMen: state.botonMen,
  };
};
const mapDispatchToProps = {
  saveCliente,
  saveToken,
  saveBotonMensaje,
};

export default connect(mapStateToProps, mapDispatchToProps)(Chat);

const Container = styled.div`
  height: 80vh;
`;

const Sidebar = styled.aside`
  /* width: calc(100% - 275px); */
  width: 100%;
  border-right: solid 1px #eee;
  height: 30%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  float: left;
`;

const MessagesContent = styled.section`
  /* width: calc(100% - 275px); */
  width: 100%;
  height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  float: left;
  background-color: #ecf0f6;
`;
const MessagesContent2 = styled.section`
  /* width: calc(100% - 275px); */
  width: 100%;
  height: 30%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  float: left;
`;

const FieldContainer = styled.div`
  /* width: calc(100% - 275px); */
  width: 100%;
  height: 120px;
  border: 3px solid #d8e1ee;
  align-items: flex-start;
  background-color: #ecf0f6;
`;

const FieldContainer4 = styled.div`
  /* width: calc(100% - 275px);
  height: 150px; */
  display: flex;
  align-items: flex-start;
`;

const FieldContainer1 = styled.div`
  width: 100%;
  padding: 10px;
`;
const FieldContainer2 = styled.div`
  width: 100%;
  padding: 10px;
`;

const FieldContainer3 = styled.div`
  padding: 10px;
`;
const FieldContainer5 = styled.div`
  padding: 10px;
`;
const FieldContainer6 = styled.div`
  max-width: 100%;
  height: 40px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* background-color: #fff; */
  font-weight: bold;
`;
const FieldContainer7 = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;
const FieldContainer8 = styled.div`
  padding: 10px;
  text-align: center;
`;
const Span = styled.span`
  padding: 3px;
  font-size: 20px;
  font-weight: bold;
`;
const Span2 = styled.span`
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 3px;
  font-size: 20px;
  font-weight: bold;
`;
const Salir = styled.button`
  border-radius: 3px;
  width: 10%;
  height: 100%;
  border: solid 1px #eee;
  background-color: #028d7b;
  text-align: center;
  transition: all 0.3s;
  :hover {
    opacity: 0.8;
  }
  svg {
    width: 20px;
    stroke: #ffff;
  }
`;

const LinkContainer = styled.div`
  a {
    position: relative;
    float: right;

    text-align: center;
    background: #fff;

    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-decoration: none !important;
    color: inherit !important;
    font-size: 12px;
    padding-top: 5px;
    svg {
      width: 20px;
      height: 20px;
      stroke: #888 !important;
      transition: all 0.3s ease;
    }
    :hover svg {
      opacity: 0.8;
    }
  }
`;
const BadgeNotification = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #f00;
  border-radius: 50%;
  top: -2px;
  right: -1px;
`;

const Boton = styled.button`
  text-align: center;
  background: #fff;
  border-radius: 50%;
  border: none;
  width: 30px;
  height: 30px;
  text-decoration: none !important;
  color: inherit !important;
  font-size: 12px;
  padding-top: 5px;
`;

const Flotador3xM = styled.div`
  margin-top: 0px;
  position: absolute;
  height: 70%;
  width: 97%;
  align-content: center;
  justify-content: center;
  z-index: 10;
  background-color: #3c6cb3;
`;

const Flotador1 = styled.div`
  align-self: flex-start;
  width: 100%;
`;

const FechasL = styled.div`
  text-align: center;
`;
const Selecte = styled.select`
  width: 50%;
`;
const BotonS = styled.button`
  color: #070707;
  background-color: #fff;
  outline: none;
  border: solid 2px#C8C8C8;
  font-size: 15px !important;
  padding: 8px 8px;
  border-radius: 10px;
  font-weight: bold;
  margin-bottom: 5%;
  margin-top: 20px;
  margin-right: 10px;
  :hover {
    color: #fff;
    background-color: #3b76c4;
  }
`;
